import { Component, OnInit, ViewChild, Input, ChangeDetectorRef } from '@angular/core';
import { SubmitCancelComponent } from "@Common/events";

import { DeleteComponent } from "./delete/delete.component";
import  KeyStore  from "../../key-store";


const VALID_START_STRINGS = [
  '-----BEGIN RSA PRIVATE KEY-----',
  '-----BEGIN PRIVATE KEY-----',
  '-----BEGIN ENCRYPTED PRIVATE KEY-----'
];


@Component({
standalone: false,
  selector: 'fx-ssh-manage',
  templateUrl: './manage.component.html',
  styleUrls: ['./manage.component.css']
})
export class ManageComponent extends SubmitCancelComponent implements OnInit {
  keyStore = new KeyStore ();
  error:any;
  @ViewChild ("close", {static: false}) closeButton;
  @Input() newPosition = false;
  @Input() hideSaveButton = false;
  constructor(private cdr: ChangeDetectorRef) { super (); }
  
  gridOptions  = {
    rowSelection: 'single',
   // dataKey: 'key',
    deleteRowButton: true,
    onCloseRowClicked: (rowData) => {
      this.keyStore.deleteKey (rowData.key);
      this.gridOptions.data = this.keyStore.read ();
      this.cdr.detectChanges();
    },
    columnDefs: [
      {
        headerName: 'Private Key',
        field: 'name',
        deleteRowButton: true,
       
      },
    ],
   
  } as any;
  onSelectionChanged($event) {
    // console.log($event);
  }
  ngOnInit() {
    this.gridOptions.data = this.keyStore.read().map(c => { c.id = c.key; return c });
  }
  ngAfterViewInit () {
    if(this.closeButton && this.closeButton.submitButton)
      this.closeButton.submitButton.text =  'Done';
    this.cdr.detectChanges();
  }
  float() {
    return this.newPosition ? 'float-start' : 'float-end';
  }
 
  open () {
    (new Promise ((resolve, reject) => {
      let el = document.createElement ('input');
      el.type = 'file'
      el.multiple = true;
      el.onchange = (e: any) => {
        resolve (e.path ? e.path [0].files : e.target.files);
      }
      el.click ();
    }))
    .then (d => {
      let reader = new FileReader();
      reader.onload = (evt: any) => {
        let i = 0;
        while(i < VALID_START_STRINGS.length) {
          if(evt.target.result.startsWith(VALID_START_STRINGS[i])) {
            this.keyStore.add (d [0].name ,evt.target.result);
            this.gridOptions.data = this.keyStore.read ();
            return;
          }
          i++;
        }
        this.error = new Error("Invalid Key Format")
       
      }
      reader.readAsText (d [0])
    })
    .catch (e => { this.error = e });
  }
  onSubmit () {
    this.submit.emit ();
  } 

}
